import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import API from '../../config/config';

const CarouselImageWidget = (props: any) => {
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined
    });
    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return dimension
  }
  const responsive = {
    desktop: {
      breakpoint: { max: 20000, min: 990 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 990, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  return (
    <div className="container" id="learn">
      <div className="carouselimage-size" >
        <Carousel
          swipeable
          draggable
          showDots
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite
          autoPlay={false}
          autoPlaySpeed={5000}
          arrows={false}
          keyBoardControl
          customTransition="transform 500ms ease-in-out"
          transitionDuration={0}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          deviceType={props.deviceType}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {props.data.map((item: any, i: any) => {
            return (
              <React.Fragment key={i}>
                <div className={windowSize.width >= 768 ? 'show' : 'hide'}>
                  <Row key={i} className="align-items-center text-select-disable" xs={1} md={2}>
                    <Col className="display-carouselimg">
                      {item.image.mime !== 'video/mp4' ? (
                        <div
                          className="carouselimage-img "
                          style={{
                            backgroundImage: `url(${item.image ? API.baseUrl + item.image.url : ''})`
                          }}
                        />
                      ) : (
                        <video className="carouselimage-img " src={API.baseUrl + item.image.url} autoPlay muted loop >
                          {/* <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track> */}
                        </video>

                      )}
                    </Col>
                    <Col>
                      <div className="carouselimage-flex-content">
                        <div className="carouselimage-h2-widget-title">{item.title}</div>
                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className={windowSize.width < 768 ? 'show' : 'hide'}>
                  <Row key={i} className="align-items-center text-select-disable" xs={1} md={2}>
                    <Col>
                      <div className="carouselimage-flex-content">
                        <div className="carouselimage-h2-widget-title">{item.title}</div>
                      </div>
                    </Col>
                    <Col className="display-carouselimg">
                      {item.image.mime !== 'video/mp4' ? (
                        <div
                          className="carouselimage-img "
                          style={{
                            backgroundImage: 'url(' + API.baseUrl + item.image.url + ')'
                          }}
                        />
                      ) : (
                        <video className="carouselimage-img " src={API.baseUrl + item.image.url} autoPlay muted loop >
                          {/* <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track> */}
                          +                        </video>
                      )}
                    </Col>
                    <Col>
                      <div className="carouselimage-flex-content">
                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                      </div>
                    </Col>
                  </Row>
                </div>
              </React.Fragment>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default CarouselImageWidget;
